import React from 'react';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import './LineItemDeliveryNotes.scss';

type Props = {
  item: LineItem;
};

export const LineItemDeliveryNotes: React.FC<Props> = ({
  item: {
    attributes: { customerDeliveryNotes }
  }
}) => {
  if (!customerDeliveryNotes) return null;

  return <div className="LineItemDeliveryNotes">{customerDeliveryNotes}</div>;
};
